import { API_URLS } from "../api_config/api_routes";
import { request } from "../api_config/api_config";

// JOIN VIDEO CALL AS DOCTOR
export const joinCallDoctor_api = async ({ appointmentId }) => {
  try {
    const res = await request.post(API_URLS.join_call_doctor_api_url, {
      appointmentId,
    });
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};

// JOIN VIDEO CALL AS PATIENT
export const joinCallPatient_api = async ({ appointmentId }) => {
  try {
    const res = await request.post(API_URLS.join_call_patient_api_url, {
      appointmentId,
    });
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};
